import { Navigate, RouteObject } from "react-router";

import { convertRouteModule } from "../../lib/routing";

export const actionPlanRoutes: Array<RouteObject> = [
  {
    path: "*",
    id: "action-plan",
    lazy: async () => convertRouteModule(await import("./action/actions")),
    children: [
      { index: true, element: null },
      {
        path: ":actionId",
        id: "edit-action-plan",
        lazy: async () => convertRouteModule(await import("./action/edit-action")),
        children: [
          {
            index: true,
            element: <Navigate to="general" replace />,
          },
          {
            path: "general",
            lazy: async () =>
              convertRouteModule(await import("./action/forms/general-information-form")),
          },
          {
            path: "reduction",
            lazy: async () => convertRouteModule(await import("./action/forms/reduction-form")),
          },
          {
            path: "cost-efficiency",
            lazy: async () =>
              convertRouteModule(await import("./action/forms/cost-efficiency-form")),
          },
          {
            path: "documents",
            lazy: async () => convertRouteModule(await import("./action/forms/action-documents")),
          },
        ],
      },
    ],
  },
];
